var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('div',{staticClass:"fb-share-button",attrs:{"data-href":_vm.url,"data-layout":"button_count","data-size":"large"}},[_c('a',{staticClass:"fb-xfbml-parse-ignore",attrs:{"target":"_blank","href":`https://www.facebook.com/sharer/sharer.php?u=${_vm.encodedUrl};src=sdkpreparse`}},[_vm._v("Share")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }